import { render, staticRenderFns } from "./prerequisite.vue?vue&type=template&id=45fa119c&"
import script from "./prerequisite.vue?vue&type=script&lang=js&"
export * from "./prerequisite.vue?vue&type=script&lang=js&"
import style0 from "./prerequisite.vue?vue&type=style&index=0&id=45fa119c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports